<template>
  <div id="planContainer">
    <div style="border-bottom: 1px solid #d3d9e8c4; padding: var(--middle-space) var(--big-space)">
      <p style="font-size: 16px; font-weight: 600; color: var(--key-color)">计划进度</p>
    </div>
    <div class="navBox">
      <div class="operations" style="float: left">
        <el-button v-if="addProgress" type="primary" icon="el-icon-plus" size="small" @click="add('')"> 新增计划 </el-button>
        <el-button type="primary" size="small" @click="showTypeChange">
          {{ showType ? "隐藏关键计划" : "显示关键计划" }}
        </el-button>
        <el-button v-if="importProgress" type="primary" icon="el-icon-download" size="small" plain @click="importTask"> 导入 </el-button>
        <el-button v-if="exportProgress" type="primary" icon="el-icon-upload2" size="small" plain @click="exportTask"> 导出 </el-button>
        <el-button type="primary" size="small" plain @click="isShowMapDocs = true"> 图例说明 </el-button>
        <el-button v-if="editProgress" type="primary" :disabled="!currentTaskId" icon="el-icon-connection" size="small" plain @click="linkTask"> 链接计划 </el-button>
        <el-select v-model="mapTypeValue" size="small" placeholder="请选择" style="margin: 0 10px; width: 150px" filterable @change="mapChange">
          <el-option v-for="item in mapTypeArr" :key="item.value" :label="item.name" :value="item.value"> </el-option>
        </el-select>
        <el-select
          v-model="labelFilterValue"
          size="small"
          clearable
          style="margin: 0 0px"
          value-key="id"
          multiple
          collapse-tags
          placeholder="专业选择"
          filterable
          @change="labelChange"
        >
          <el-option v-for="item in taskLabelList" :key="item.id" :label="item.cnName" :value="item"> </el-option>
        </el-select>
        <el-select v-if="!isList" v-model="gap" placeholder="请选择时间间隔" size="small" style="width: 100px; margin-left: 10px" filterable @change="timeGapChange">
          <el-option v-for="item in gaps" :key="item.id" :label="item.label" :value="item.id"> </el-option>
        </el-select>
        <div style="margin-left: 30px">
          <img :src="tishi" alt="" style="vertical-align: middle" />
          <span style="vertical-align: middle">
            共{{ tasks.data.length }}条，其中存在警告提醒有
            <span style="color: red">{{ tasks.data.filter((item) => item.taskStatus === 3).length }}</span>
            条
          </span>
        </div>
      </div>
      <div style="float: right">
        <el-input v-model="taskSearchValue" size="small" clearable style="width: 200px; margin-left: 10px" placeholder="请输入计划名称"></el-input>
      </div>
    </div>
    <div class="content">
      <div ref="gantt" style="height: 100%"></div>
      <transition name="el-zoom-in-top">
        <div v-if="isShowSetHeader" class="setHeader el-select-dropdown" :style="{ left: setHeaderLeft, top: setHeaderTop }">
          <div class="set-tips">请选择表头显示内容</div>
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="wbs" disabled> 编号 </el-checkbox>
            <el-checkbox label="taskName" disabled> 名称 </el-checkbox>
            <el-checkbox label="taskProgress" disabled> 进度 </el-checkbox>
            <el-checkbox label="isMilestone">里程碑</el-checkbox>
            <el-checkbox label="labelName"> 专业 </el-checkbox>
            <el-checkbox label="originalChildId">{{ $titles.child }}</el-checkbox>
            <el-checkbox label="startDate"> 计划开始时间 </el-checkbox>
            <el-checkbox label="endDate"> 计划结束时间 </el-checkbox>
            <el-checkbox label="realEndDate"> 实际完成时间 </el-checkbox>
            <el-checkbox label="planSchedule"> 工期 </el-checkbox>
            <el-checkbox label="taskTypeName"> 计划类型 </el-checkbox>
            <el-checkbox label="preTaskName"> 紧前计划 </el-checkbox>
            <el-checkbox label="afterTaskName"> 紧后计划 </el-checkbox>
            <el-checkbox label="taskUserName"> 责任人 </el-checkbox>
            <el-checkbox label="createUserName"> 创建人 </el-checkbox>
            <el-checkbox label="taskStatusName"> 状态 </el-checkbox>
            <el-checkbox label="buttons" disabled> 操作 </el-checkbox>
          </el-checkbox-group>
          <div class="btns">
            <el-button size="mini" type="primary" @click="setHeaderConfirm"> 确定 </el-button>
            <el-button size="mini" @click="cancelSetHeader"> 取消 </el-button>
          </div>
        </div>
      </transition>
      <div v-show="mapTypeValue === '0'" class="foldBtn" :style="{ left: `calc(${gridCellW + 1}px + 31px` }" @click="toggleFold">
        {{ foldStatus ? "收起" : "展开" }}
      </div>
    </div>
    <el-dialog id="eldialogtop3" v-dialogDrag title="导入计划包" :visible.sync="dialogFormVisible3" :close-on-click-modal="false" :close-on-press-escape="false">
      <leadingin :key="dd" ref="leadingin"></leadingin>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible3 = false"> 取 消 </el-button>
        <el-button type="primary" size="small" @click="adddaoru"> 确 定 </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="currentTask.preTaskList"
      v-dialogDrag
      class="linkTask"
      title="链接计划"
      :visible.sync="isShowLinkTaskBox"
      width="40%"
      top="17vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="linkTaskClose"
    >
      <div class="linkTask_content" style="margin-bottom: 20px">
        <div class="top">
          <div class="titlecalss">
            <span style="font-weight: bold; font-size: 14px">紧前计划</span>
            <el-button type="primary" icon="el-icon-plus" size="small" plain @click="(isShowPreTaskBox = true), queryTreeTask()"> 添加 </el-button>
          </div>
          <div class="warp">
            <!-- <el-row v-if=" currentTask.preTaskList.filter( item => item.relaStatus === '1' )[0] " :gutter="0">
              <el-col :span="24">
                <div>开始-开始：以下计划开始后，当前计划才能开始</div>
                <div v-for="(item, index) in currentTask.preTaskList.filter( item => item.relaStatus === '1' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 1) }}</span>
                    {{ item.preTaskName || item.taskName }}</span>
                  <span>
                    <i class="el-icon-close" style="color: red; cursor: pointer" @click="delPreTask(item, index)"></i>
                  </span>
                </div>
              </el-col>
            </el-row> -->
            <el-row v-if="currentTask.preTaskList.filter((item) => item.relaStatus === '0')[0]" :gutter="0" style="margin-top: 15px">
              <el-col :span="24">
                <div>完成-开始：以下计划完成后，当前计划才能开始</div>
                <div
                  v-for="(item, index) in currentTask.preTaskList.filter((item) => item.relaStatus === '0')"
                  :key="index"
                  class="item"
                  style="display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee"
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 1) }}</span>
                    {{ item.preTaskName || item.taskName }}</span
                    >
                  <span>
                    <i class="el-icon-close" style="color: red; cursor: pointer" @click="delPreTask(item, index)"></i>
                  </span>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="!currentTask.preTaskList[0]" :gutter="0" style="height: 100%; display: flex; align-items: center">
              <el-col :span="24">
                <div style="text-align: center">
                  <img :src="zanwu" alt="" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="linkTask_content">
        <div class="bottom">
          <div class="titlecalss">
            <span style="font-weight: bold; font-size: 14px">紧后计划</span>
          </div>
          <div class="warp">
            <!-- <el-row v-if=" currentTask.afterTaskList.filter( item => item.relaStatus === '1' )[0] " :gutter="0">
              <el-col :span="24">
                <div>开始-开始：当前计划开始后，以下计划才能开始</div>
                <div v-for="(item, index) in currentTask.afterTaskList.filter( item => item.relaStatus === '1' )"
                  :key="index" class="item"
                  style=" display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee; ">
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 2) }}</span>
                    {{ item.taskName }}</span>
                </div>
              </el-col>
            </el-row> -->

            <el-row v-if="currentTask.afterTaskList.filter((item) => item.relaStatus === '0')[0]" :gutter="0">
              <el-col :span="24">
                <div>完成-开始：当前计划结束后，以下计划才能开始</div>
                <div
                  v-for="(item, index) in currentTask.afterTaskList.filter((item) => item.relaStatus === '0')"
                  :key="index"
                  class="item"
                  style="display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid #eee"
                >
                  <span style="color: #538be6">
                    <span style="margin-right: 10px">{{ getWBSCode(item, 2) }}</span>
                    {{ item.taskName }}</span
                  >
                </div>
              </el-col>
            </el-row>

            <el-row v-if="!currentTask.afterTaskList[0]" :gutter="0" style="height: 100%; display: flex; align-items: center">
              <el-col :span="24">
                <div style="text-align: center">
                  <img :src="zanwu" alt="" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer" style="padding: 10px 0px 10px">
        <el-button size="small" @click="linkTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addLinkTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      class="preTask"
      title="紧前计划"
      :visible.sync="isShowPreTaskBox"
      width="30%"
      top="20vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="preTaskClose"
    >
      <div class="preTask_content">
        <div class="top">
          <span>选择紧前计划链接关系</span>
          <div>
            <!-- <el-radio v-model="preTaskRadio" label="1">
              开始-开始（所关联紧前计划开始后，当前计划才能开始）
            </el-radio> -->
            <el-radio v-model="preTaskRadio" label="0"> 完成-开始（所关联紧前计划完成后，当前计划才能开始） </el-radio>
          </div>
        </div>
        <div class="bottom">
          <span>选择紧前计划</span>
          <div class="tree">
            <el-input v-model="preTaskFilterText" size="small" style="width: 100%; margin-bottom: 10px" placeholder="输入关键字进行过滤" clearable> </el-input>
            <div class="treeWarp">
              <el-tree
                ref="preTaskTree"
                :key="updateKey"
                check-strictly
                default-expand-all
                :filter-node-method="preTaskFilterNode"
                :data="treeTask"
                node-key="taskId"
                :props="defaultProps"
                show-checkbox
                style="background: #f6f9fe"
                @check="handlePreTaskCheckChange"
              >
                <span slot-scope="{ node, data }" class="custom-tree-node">
                  <span>
                    <span style="margin-right: 10px">{{ getWBSCode(data, 2) }}</span>
                    {{ node.label }}
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="preTaskClose">取 消</el-button>
        <el-button type="primary" size="small" @click="addPreTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      class="mapDocs"
      title="图例说明"
      :visible.sync="isShowMapDocs"
      width="30%"
      top="25vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="isShowMapDocs = false"
    >
      <div class="content">
        <div class="warp">
          <div class="item">
            <div class="progress" style="background: #69e2b3">
              <div class="solid" style="background: #22ac76"></div>
            </div>
            <div>进行中</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #fdd2d2">
              <div class="solid" style="background: #f75c5c"></div>
            </div>
            <div>已超期</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #dcdcdc"></div>
            <div>未开始</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #a4bafa">
              <div class="solid" style="background: #4689f6; width: 100%"></div>
            </div>
            <div>已完成</div>
          </div>
          <div class="item">
            <div class="progress" style="background: #fdfab6">
              <div class="solid" style="background: #f4ea05"></div>
            </div>
            <div>已暂停</div>
          </div>
          <!-- <div class="item">
            <div class="progress" style="background: var(--theme-color); height: 2px"></div>
            <div class="link_arrow" style="border-left-color: var(--theme-color)"></div>
            <div>开始-开始</div>
          </div> -->
          <div class="item">
            <div class="progress" style="background: purple; height: 2px"></div>
            <div class="link_arrow"></div>
            <div>完成-开始</div>
          </div>

          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../../assets/fileTable/keyTask.png" alt="" />
            </div>
            <div>里程碑</div>
          </div>
          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../../assets/fileTable/urging.png" alt="" />
            </div>
            <div>已催办</div>
          </div>
          <div class="item">
            <div class="progress" style="justify-content: center">
              <img style="width: 13px; margin: 0 4px" src="../../../../assets/fileTable/overdue.png" alt="" />
            </div>
            <div>已超期</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="isShowMapDocs = false">取 消</el-button>
        <el-button type="primary" size="small" @click="isShowMapDocs = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      :title="`${$titles.child}分组管理`"
      :visible.sync="dialogChildIyemVisible"
      width="30%"
      top="25vh"
      class="mapDocs"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table :data="childItemGroupList" height="440px" border>
        <el-table-column property="GroupName" :label="`${$titles.child}分组名称`" width="200"></el-table-column>
        <el-table-column property="PlanItems" :label="`包含${$titles.child}`"></el-table-column>
        <el-table-column property="State" label="状态">
          <template slot-scope="{ row }">
            <el-tag :type="row.State == 1 ? 'danger' : 'success'">
              {{ row.State == 1 ? "禁用" : "启用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="changeGroupStatus(row)">
              {{ row.State == 1 ? "启用" : "禁用" }}
            </el-button>
            <el-button type="text" size="small" @click="editChildItemGroup(row)"> 编辑 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer" style="height: 25px">
        <el-button size="small" @click="dialogChildIyemVisible">取 消</el-button>
        <el-button style="float: right" type="primary" size="small" @click="addChildItemGroup"> 新增{{ $titles.child }}分组 </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-dialogDrag
      class="mapDocs"
      :title="`${$titles.child}分组管理`"
      :visible.sync="addchildItemGroupVisible"
      width="30%"
      top="30vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content childItemGroup">
        <el-form ref="childItemGroupForm" :model="childItemGroupForm" :rules="childItemGroupRules" label-width="100px" label-position="top" size="small" style="width: 100%">
          <el-form-item :label="`请输入${$titles.child}分组名称`" prop="GroupName">
            <el-input v-model="childItemGroupForm.GroupName"></el-input>
          </el-form-item>
          <el-form-item :label="`请选择包含${$titles.child}`" prop="PlanItems">
            <el-select v-model="childItemGroupForm.PlanItems" :placeholder="`请选择包含${$titles.child}`" multiple style="width: 100%" filterable>
              <el-option v-for="(item, index) in childItemList" :key="item.StageChildName + index" :label="item.StageChildName" :value="item.StageChildName"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addchildItemGroupVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="saveChildItemGroup('add')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag class="add-edit-detail" title="计划管理" :visible.sync="addEditDetailVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <check-add-edit ref="box11" :task="curTaskId" :show-type="curShowType" @dialogClose="dialogClose"> </check-add-edit>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import gantt from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import request from "@/CommonDP/service/progress-service";
import { mapState } from "vuex";
import { prjplantaskexportexcel, downloadFile } from "@/CommonDP/utils";
import leadingin from "@/CommonDP/components/leadingin";
import taskPackageservice from "@/CommonDP/service/taskPackage-service";
import checkAddEdit from "./taskDetail";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import throttle from "lodash/throttle";

export default {
  name: "TaskList",
  components: {
    leadingin,
    checkAddEdit
  },
  data() {
    return {
      originColumns: [
        {
          name: "wbs",
          label: "编号",
          width: 60,
          template: gantt.getWBSCode,
          align: "left"
        },
        {
          name: "taskName",
          tree: true,
          label: "名称",
          width: 200,
          align: "left",
          resize: true,
          template: function (task) {
            // todo
            let imgEle = "";
            if (task.isMilestone) {
              // 关键计划
              imgEle += `<p class="keyTask" style="width: 13px;margin: 0 2px;"></p>`;
            }
            if (task.taskStatus === 3) {
              // 超期
              imgEle += `<p class="overdue" style="margin: 0 2px;"></p>`;
            }
            if (task.urgeHistory === 1) {
              // 催办状态
              imgEle += `<p class='urging' style="width: 13px;margin: 0 2px;"></p>`;
            }
            if (imgEle.length < 1) {
              imgEle = ``;
            }
            let taskName = `<p style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:80%;'>${task.taskName}</p>`;
            if (task.isSuspend === 1) {
              taskName = `<p style='overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:80%;color: red'>${task.taskName}</p>`;
            }
            return `<div style="display: flex;align-items: center;width:200px" title="${task.taskName}" class="">${imgEle}${taskName}</div>`;
          }
        },
        {
          name: "taskProgress",
          label: "进度",
          align: "center",
          width: 50,
          template: function (task) {
            return Math.round(task.progress * 100) + "%";
          }
        },
        {
          name: "isMilestone",
          label: "里程碑",
          align: "center",
          width: 100,
          template: function (task) {
            return task.isMilestone === 1 ? "是" : "否";
          }
        },
        {
          name: "labelName",
          label: "专业",
          width: 100,
          align: "center",
          template: function (task) {
            return `<div title="${task.labelName || ""}" class="">${task.labelName || ""}</div>`;
          }
        },
        {
          name: "originalChildId",
          label: this.$titles.child,
          width: 100,
          align: "center",
          template: function (task) {
            return `<div title="${task.originalChildId || ""}" class="">${task.originalChildId || ""}</div>`;
          }
        },
        {
          name: "startDate",
          label: "计划开始时间",
          align: "center",
          width: 150
        },
        {
          name: "endDate",
          label: "计划结束时间",
          align: "center",
          width: 150
        },
        {
          name: "realEndDate",
          label: "实际完成时间",
          align: "center",
          width: 150,
          template: function (task) {
            return `<div title="${task.realEndDate || ""}" class="">${task.realEndDate || ""}</div>`;
          }
        },
        {
          name: "planSchedule",
          label: "工期",
          align: "center",
          width: 40
        },
        {
          name: "taskTypeName",
          label: "计划类型",
          align: "center",
          width: 100,
          template: function (task) {
            return `<div title="${task.taskTypeName || ""}" class="">${task.taskTypeName || ""}</div>`;
          }
        },
        {
          name: "preTaskName",
          label: "紧前计划",
          align: "center",
          width: 100,
          template: function (task) {
            return `<div title="${task.preTaskName || ""}" class="">${task.preTaskName || ""}</div>`;
          }
        },
        {
          name: "afterTaskName",
          label: "紧后计划",
          align: "center",
          width: 100,
          template: function (task) {
            return `<div title="${task.afterTaskName || ""}" class="">${task.afterTaskName || ""}</div>`;
          }
        },
        {
          name: "taskUserName",
          label: "责任人",
          align: "center",
          width: 100,
          template: function (task) {
            return `<div title="${task.taskUserName || ""}" class="">${task.taskUserName || ""}</div>`;
          }
        },
        {
          name: "createUserName",
          label: "创建人",
          align: "center",
          width: 50,
          template: function (task) {
            return `<div title="${task.createUserName || ""}" class="">${task.createUserName || ""}</div>`;
          }
        },
        {
          name: "taskStatusName",
          label: "状态",
          align: "center",
          width: 70,
          template: function (task) {
            return `<div class="task-status task-status-${task.taskStatus}">${task.taskStatusName}</div>`;
          }
        },
        {
          name: "buttons",
          label: "操作",
          width: 220,
          align: "center",
          template: () => {
            return `<div class="operations">
                <p title="催办" class='urgent'></p>
                <p title="编辑" class='edit edit-${this.editProgress}'></p>
                <p title="添加" class='add add-${this.addProgress}'></p>
                <p title="详情" class='detail'></p>
                <p title="删除" class='del del-${this.delProgress}'></p>
                <p title="上移" class='shangyi edit-${this.editProgress}'></p>
                <p title="下移" class='xiayi edit-${this.editProgress}'></p>
                <p title="升级" class='shengji edit-${this.editProgress}'></p>
                <p title="降级" class='jiangji edit-${this.editProgress}'></p>
              </div>`;
          }
        },
        {
          name: "headerSet",
          label: this.newLabel(),
          align: "center",
          width: 40
        }
      ],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      addEditDetailVisible: false,
      curShowType: "",
      curTaskId: "",
      gaps: [
        { id: 0, label: "一天" },
        { id: 1, label: "两天" },
        { id: 2, label: "一周" },
        { id: 3, label: "一月" }
      ],
      gap: 0,
      mapTypeArr: [
        {
          name: "甘特图",
          value: "0"
        },
        {
          name: "列表",
          value: "1"
        }
      ],
      mapTypeValue: "0",
      showType: false,
      treeTask: [],
      updateKey: 0,
      splicePreTaskList: [],
      preTaskChecks: [],
      defaultProps: {
        children: "childList",
        label: "taskName"
      },
      isShowMapDocs: false,
      isShowLinkTaskBox: false,
      isShowPreTaskBox: false,
      preTaskRadio: "0",
      preTaskFilterText: "",
      taskLabelList: [], // 所有专业
      labelFilterValue: [],
      taskSearchValue: "",
      currentTaskId: "",
      currentTask: {},
      foldStatus: false, // 就是甘特图状态下全是列表 false就是甘特图状态下列表和甘特图
      isShowSetHeader: false,
      setHeaderLeft: "",
      setHeaderTop: "52px",
      gridCellW: "",
      oldCheckListGantt: ["wbs", "taskName", "taskProgress", "buttons", "headerSet"],
      oldCheckListList: [
        "wbs",
        "taskName",
        "taskProgress",
        "isMilestone",
        "labelName",
        "startDate",
        "endDate",
        "realEndDate",
        "planSchedule",
        "taskTypeName",
        "preTaskName",
        "afterTaskName",
        "taskUserName",
        "createUserName",
        "taskStatusName",
        "buttons",
        "headerSet"
      ],
      checkList: ["wbs", "taskName", "taskProgress", "buttons", "headerSet"],
      tasks: {
        data: [],
        links: []
      },
      filterColumns: [],
      baseColumns: ["wbs", "taskName", "taskProgress", "buttons", "headerSet"],
      locale: {
        date: {
          month_full: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
          month_short: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          day_full: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
          day_short: ["日", "一", "二", "三", "四", "五", "六"]
        },
        labels: {
          dhx_cal_today_button: "今天",
          day_tab: "日",
          week_tab: "周",
          month_tab: "月",
          new_event: "新建日程",
          icon_save: "保存",
          icon_cancel: "关闭",
          icon_details: "详细",
          icon_edit: "编辑",
          icon_delete: "删除",
          confirm_closing: "请确认是否撤销修改!", // Your changes will be lost, are your sure?
          confirm_deleting: "是否删除日程?",
          section_description: "描述",
          section_time: "时间范围",
          section_type: "类型",
          column_text: "计划名",
          column_start_date: "开始时间",
          column_duration: "持续时间",
          column_add: "",
          message_ok: "确定",
          message_cancel: "取消",

          link: "关联",
          confirm_link_deleting: "将被删除",
          link_start: " (开始)",
          link_end: " (结束)",

          type_task: "计划",
          type_project: "项目",
          type_milestone: "里程碑",

          minutes: "分钟",
          hours: "小时",
          days: "天",
          weeks: "周",
          months: "月",
          years: "年"
        }
      },
      dialogFormVisible3: false,
      dd: "",
      daorupackage: {},
      setParentDisabledArr: new Set(),
      myTaskClickEvent: null,

      childItemGroupValue: "",
      childItemGroupList: [],
      childItemList: [],
      dialogChildIyemVisible: false,
      addchildItemGroupVisible: false,
      childItemGroupForm: {
        GroupName: "",
        PlanItems: []
      },
      childItemGroupRules: {
        GroupName: [{ required: true, message: "请输入" + this.$titles.child + "分组名称", trigger: "blur" }],
        PlanItems: [{ required: true, message: "请选择所包含的" + this.$titles.child, trigger: "change" }]
      },
      tishi: require("@/CommonDP/assets/settings/tishi.png"),
      isList: false
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    childItemGroupListFiltered() {
      return this.childItemGroupList.filter((item) => item.State === 0);
    },
    // 当前状态下的甘特列数据
    doFilterColumns() {
      const { foldStatus, baseColumns, originColumns, filterColumns } = this;
      const colMap = {};
      for (const item of originColumns) colMap[item.name] = item;
      const allName = originColumns.map(({ name }) => name);
      const col_filter = allName.filter((name) => filterColumns.indexOf(name) !== -1);
      const hasFilter = !!col_filter.length;
      const cols = hasFilter ? col_filter : foldStatus ? allName : baseColumns;
      // 因为gantt会修改width的值,所以我们需要对数据进行拷贝,防止需改原有结构
      return cols.map((name) => {
        const old = colMap[name];
        const item = { ...old };
        let _width = old.width;
        // 同时对width进行值(set/get)控制,禁止宽度超出预设的值
        const max_width = old.max_width || Infinity;
        const min_width = old.min_width || old.width;
        Object.defineProperty(item, "width", {
          get() {
            return _width;
          },
          set(val) {
            _width = Math.min(Math.max(val, min_width), max_width);
          }
        });
        return item;
      });
    },
    addProgress() {
      return checkPermission(this.$allPerms.PROGRESSLIST_ADD);
    },
    exportProgress() {
      return checkPermission(this.$allPerms.PROGRESSLIST_EXPORT);
    },
    importProgress() {
      return checkPermission(this.$allPerms.PROGRESSLIST_IMPORT);
    },
    editProgress() {
      return checkPermission(this.$allPerms.PROGRESSLIST_EDIT);
    },
    delProgress() {
      return checkPermission(this.$allPerms.PROGRESSLIST_DEL);
    }
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function ({ prjId }, oldValue) {
        if (prjId) {
          this.resetCurrentTask();
          this.initTaskData(true);
          this.queryChildItemList();
          this.querychildItemGroupList();
        }
      }
    },

    preTaskFilterText(val) {
      this.$refs.preTaskTree.filter(val);
    },

    taskSearchValue(value, oldValue) {
      const selectTask = gantt.getSelectedTasks();
      selectTask.forEach((item) => {
        gantt.toggleTaskSelection(item);
      });
      gantt.render();
      if (value) {
        const tasks = gantt.getTaskByTime();
        tasks.forEach((item) => {
          if (item.taskName.includes(value)) {
            gantt.toggleTaskSelection(item.id);
          }
        });
        gantt.render();
      }
    }
  },
  mounted() {
    this.initDic();
    this.initGantt();
    this.initTaskData();
    this.initGanttRender();
    this.clientLeftResize();
  },
  methods: {
    onGanttRender() {
      if (gantt.$grid_data && gantt.$grid_scale) {
        gantt.$grid_data.style.width = gantt.$grid_scale.clientWidth + "px";
      }
      this.clientLeftResize();
    },
    initGanttRender() {
      const event = gantt.attachEvent("onGanttRender", this.onGanttRender);
      this.$on("hook:destroyed", () => {
        gantt.detachEvent(event);
      });
    },
    clientLeftResize: throttle(async function () {
      await this.$nextTick();
      this.gridCellW = this.getGridCellWidth();
      this.setHeaderLeft = this.gridCellW - 140 + 15 + "px";
    }, { wait: 100 }),
    dialogClose(isRefresh) {
      this.addEditDetailVisible = false;
      if (isRefresh) this.initTaskData();
    },
    initDic() {
      this.queryTaskLabelList();
      this.queryTreeTask();
      this.querychildItemGroupList();
      this.queryChildItemList();
    },
    getWBSCode(task, type) {
      if (type === 1) return gantt.getWBSCode(gantt.getTask(task.preTaskId));
      return gantt.getWBSCode(gantt.getTask(task.taskId));
    },
    addChildItemGroup() {
      this.addchildItemGroupVisible = true;
      delete this.childItemGroupForm.ID;
      this.$nextTick(() => {
        this.$refs.childItemGroupForm.resetFields();
      });
    },
    editChildItemGroup(row) {
      this.addchildItemGroupVisible = true;
      request.queryChildItemGroupById(row.ID).then((res) => {
        if (res.result === "0") {
          this.childItemGroupForm.GroupName = res.data.GroupName;
          this.childItemGroupForm.ID = res.data.ID;
          this.childItemGroupForm.PlanItems = res.data.PlanItems.split(",");
        }
      });
      // this.saveChildItemGroup("modify");
    },
    saveChildItemGroup() {
      this.$refs["childItemGroupForm"].validate((valid) => {
        if (valid) {
          let type = "";
          const { prjId } = this.prjInfo;
          const data = {
            groupName: this.childItemGroupForm.GroupName,
            basicPlanID: this.childItemGroupForm.PlanItems.join(",")
          };
          let msg = "";
          if (!this.childItemGroupForm.ID) {
            if (data.id) delete data.id;
            data.prjId = prjId;
            type = "add";
            msg = "添加";
          } else {
            if (data.prjId) delete data.prjId;
            type = "modify";
            data.id = this.childItemGroupForm.ID;
            msg = "修改";
          }
          request.saveChildItemGroup(type, data).then((res) => {
            if (res.result === "0") {
              this.querychildItemGroupList();
              this.$message.warning(msg + "成功");
              this.addchildItemGroupVisible = false;
            } else {
              this.$message.warning(res.message || msg + "失败");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    changeGroupStatus(row) {
      const { ID, State } = row;
      this.$confirm("确定要改变当前状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        request.changeGrouState({ ID, State: 1 - State }).then((res) => {
          if (res.result === "0") {
            this.querychildItemGroupList();
            this.$message.warning("修改状态成功");
          }
        });
      });
    },
    queryChildItemList() {
      const { prjId } = this.prjInfo;
      request.queryChildItemList(prjId).then((res) => {
        this.childItemList = res.data;
      });
    },
    querychildItemGroupList() {
      const { prjId } = this.prjInfo;
      request.queryChildItemGroupList(prjId).then((res) => {
        this.childItemGroupList = res.data;
      });
    },
    queryTaskLabelList() {
      const { prjId } = this.prjInfo;
      taskPackageservice.querySpecRoleList(prjId).then((res) => {
        if (res.result === "0") {
          this.taskLabelList = res.data;
        }
      });
    },

    queryTreeTask() {
      const { prjId } = this.prjInfo;
      const isCore = 1;
      request.queryPlanList({ prjId, isCore, labelIds: [], enterpriseId: this.enterpriseId }).then((res) => {
        if (res.result === "0") {
          // this.currentTask.preTaskList紧前
          if (res.data.list) {
            for (var t = 0; t < res.data.list.length; t++) {
              if (this.currentTask.preTaskList) {
                for (var b = 0; b < this.currentTask.preTaskList.length; b++) {
                  if (res.data.list[t].taskId === this.currentTask.preTaskList[b].preTaskId) {
                    this.$set(res.data.list[t], "disabled", true);
                  }
                }
              }
              // this.currentTask.afterTaskList 紧后
              if (this.currentTask.afterTaskList) {
                for (var b2 = 0; b2 < this.currentTask.afterTaskList.length; b2++) {
                  if (res.data.list[t].taskId === this.currentTask.afterTaskList[b2].taskId) {
                    this.$set(res.data.list[t], "disabled", true);
                  }
                }
              }
            }
            this.treeTask = res.data.list;
            this.filterArray(this.treeTask, this.currentTaskId);
          }
        }
      });
    },
    filterArray(data, taskId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].taskId === taskId) {
          data[i].disabled = true;
          this.filterArray(data, data[i].parentId);
        }
      }
      this.treeTask = data;
      this.filterArray2(this.treeTask, this.currentTaskId);
    },
    filterArray2(data, id) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === id) {
          data[i].disabled = true;
          this.filterArray2(data, data[i].taskId);
        }
      }
      this.treeTask = this.filterArray1(data, "0");
    },
    filterArray1(data, parentId) {
      const tree = [];
      let temp;
      for (let i = 0; i < data.length; i++) {
        if (data[i].parentId === parentId) {
          const obj = data[i];
          temp = this.filterArray1(data, data[i].taskId);
          if (temp.length > 0) {
            obj.childList = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },

    async initTaskData(isChangePrj) {
      const { x, y } = gantt.getScrollState();
      const { prjId } = this.prjInfo;
      const isCore = this.showType ? 2 : 1;
      const labelIds = [];
      const res = await request.queryPlanList({
        prjId,
        labelIds,
        isCore,
        enterpriseId: this.enterpriseId
      });
      let { links, list } = res.data;
      links = links || [];
      list = list || [];
      list.forEach((item) => {
        item.id = item.taskId;
        item.parent = item.parentId;
        item.start_date = item.startDate;
        item.end_date = this.addOnDay(item.endDate, 1);
        item.open = true;
        item.progress = item.taskProgress / 100;
      });
      this.tasks.data = list;
      this.tasks.links = links;
      gantt.clearAll();
      gantt.config.show_errors = false;
      this.renderGantt();
      this.countGridCellW();
      if (this.currentTaskId) {
        this.currentTask = list.find((item) => item.taskId === this.currentTaskId);
      }
      this.scrollTo(isChangePrj ? 0 : x, isChangePrj ? 0 : y);
    },

    add(type, id) {
      type = type || "add";
      if (type !== "add") {
        this.$router.push({
          path: "/project-taskDetail",
          query: {
            showType: type,
            task: id || "0"
          }
        });
      } else {
        console.log("***");
        this.curShowType = type;
        this.curTaskId = id || "0";
        this.addEditDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.box11.qinkong();
        });
      }
    },

    delPreTask(item) {
      this.removeByValue(this.currentTask.preTaskList, "preTaskId", item.preTaskId);
    },
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    // 导入
    importTask() {
      this.dialogFormVisible3 = true;
      this.daorupackage = {};
      var d = new Date();
      this.dd = d.getSeconds(); // 获取秒
    },
    // 确定 导入
    async adddaoru() {
      const success = await this.$refs.leadingin.validateFormData();
      if (success) {
        this.daorupackage = await this.$refs.leadingin.taskPackage();
        const { prjId } = this.prjInfo;
        this.dialogFormVisible3 = false;
        var data = {
          packageId: this.daorupackage.id,
          enterpriseId: this.enterpriseId,
          prjId: prjId,
          dateTime: this.daorupackage.dateTime,
          taskId: ""
        };
        console.log(data, "导入成功");
        if (this.currentTaskId) {
          data.taskId = this.currentTaskId;
        }
        taskPackageservice.prjplantaskimporttask(data).then((res) => {
          if (res.result === "0") {
            this.$message({
              duration: 1000,
              message: "导入成功",
              type: "success",
              showClose: true
            });
            this.initTaskData();
          }
        });
      }
    },
    // 导出
    exportTask() {
      this.$confirm("确定要导出吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        const { prjId } = this.prjInfo;
        const downzipurl = prjplantaskexportexcel(prjId);
        this.$message({
          message: "数据已生成！",
          type: "success"
        });
        downloadFile(downzipurl);
      });
    },

    linkTask() {
      this.initTaskData();
      this.queryTreeTask();
      this.isShowLinkTaskBox = true;
    },

    configTimeGap() {
      switch (this.gap) {
        case 0:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%j %M" }
          ];
          break;
        case 1:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 2, format: "%j %M" }
          ];
          break;
        case 2:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 7, format: "%j %M" }
          ];
          break;
        case 3:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "month", step: 1, format: "%F" }
          ];
          break;

        default:
          gantt.config.scales = [
            { unit: "year", step: 1, format: "%Y" },
            { unit: "day", step: 1, format: "%j %M" }
          ];
          break;
      }
    },

    initGantt() {
      gantt.config.xml_date = "%Y-%m-%d";
      gantt.config.drag_move = false;
      gantt.config.show_grid = true; // 是否显示左侧树表格
      gantt.config.drag_progress = false;
      gantt.config.details_on_dblclick = false;
      gantt.config.drag_resize = false;
      gantt.config.grid_resize = true;

      // gantt.config.autosize = true;
      this.configTimeGap();
      gantt.templates.task_text = (start, end, task) => {
        const code = gantt.getWBSCode(task);
        return code + " " + task.taskName;
      };

      gantt.templates.link_class = function (link) {
        const { type } = link;
        if (type === "1") return "start_start_link";
        else return "end_start_link";
      };

      gantt.templates.task_class = function (start, end, task) {
        if (task.coreTask === 2) return "key";
        let taskClass = "without";
        if (task.isSuspend === 1) {
          taskClass = "isSuspend";
          return taskClass;
        }
        switch (task.taskStatus) {
          case 0:
            taskClass = "without";
            break;
          case 1:
            taskClass = "low";
            break;
          case 2:
            taskClass = "medium";
            break;
          case 3:
            taskClass = "high";
            break;
        }
        return taskClass;
      };
      gantt.attachEvent("onBeforeTaskDisplay", (id, task) => {
        const labelFilterValue = this.labelFilterValue;

        const childItemGroupValue = this.childItemGroupValue ? this.childItemGroupValue.split(";")[1] : "";
        task.open = true;
        if (!labelFilterValue[0] && !childItemGroupValue) {
          return true;
        } else {
          const taskLabelList = task.labelName ? task.labelName.split(",") : [];
          const isHas = taskLabelList.filter((item) => labelFilterValue.some((Item) => Item.cnName === item));
          const gpHas = task.prjStageChildPlanGroupName === childItemGroupValue;
          if (labelFilterValue[0] && childItemGroupValue) {
            return isHas[0] && gpHas;
          }
          if (labelFilterValue[0]) {
            return isHas[0];
          }
          if (childItemGroupValue) {
            return gpHas;
          }
        }
      });

      gantt.attachEvent("onTaskDblClick", (id, e) => {
        this.add("check", id);
        return true;
      });

      gantt.templates.timeline_cell_class = function (item, date) {
        if (date.getDay() === 0 || date.getDay() === 6) {
          return "weekend";
        }
      };

      gantt.attachEvent("onAfterLinkAdd", (id, item) => {
        this.addLinkTaskDrag(item);
      });

      gantt.attachEvent("onAfterLinkDelete", (id, item) => {
        this.delLinkTaskDbClick(item);
      });

      // gantt.config.columns = this.doFilterColumns;
      gantt.locale = this.locale;
      this.renderGantt();
      this.taskClick();
      gantt.plugins({
        multiselect: true
      });
      this.$store.commit("UPDATE_GANTT", gantt);
      this.countGridCellW();
    },

    delLinkTaskDbClick(data) {
      request.delLinkTaskDbClick(data).then((res) => {});
    },

    addLinkTaskDrag(data) {
      request.addLinkTaskDrag(data).then((res) => {});
    },

    taskClick() {
      if (!this.myTaskClickEvent) {
        this.myTaskClickEvent = gantt.attachEvent("onTaskClick", (id, e) => {
          this.currentTaskId = id;
          this.currentTask = this.tasks.data.find((item) => item.id === id);
          const title = e.target.title;
          if (title) {
            switch (title) {
              case "催办":
                this.urgePlan();
                break;
              case "编辑":
                this.add("edit", id);
                break;
              case "添加":
                this.add("add", id);
                break;
              case "详情":
                this.add("check", id);
                break;
              case "删除":
                this.delPlan(id);
                break;
              case "上移":
                this.move(id, 0);
                break;
              case "下移":
                this.move(id, 1);
                break;
              case "升级":
                this.upgrade(id, 0);
                break;
              case "降级":
                this.upgrade(id, 1);
                break;
              default:
                this.currentTaskId = id;
                this.currentTask = this.tasks.data.find((item) => item.id === id);
            }
          }
          return true;
        });
      }
    },

    urgePlan() {
      const { taskName, start_date, endDate, taskStatusName, taskId, taskUserName, taskUserList, taskType, taskTypeName, taskUserId } = this.currentTask;
      const { x, y } = gantt.getScrollState();
      this.$confirm(`计划【${taskName}】起止时间为 ${moment(start_date).format("YYYY-MM-DD")} 至 ${endDate} ，目前状态为 ${taskStatusName} 是否立即进行催办提醒?`, "催办提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        //  prjId 项目id
        //  topic 主题           催办提醒: 计划名称
        //  targetItemType 待办大类(数字))  0
        //  urgeObjectiveUserId   催办人员id,通过| 拼接
        //  urgeObjectiveName 催办人员名称,通过|分割
        //  targetItemId 催办事项Id
        //  specificItemType 待办小类(数字) 0:催办 1：修改责任人
        if (taskUserList.length > 0) {
          const { prjId } = this.prjInfo;
          // let urgeObjectiveUserId = (taskUserList || [])
          //   .map((item) => item.taskUserId)
          //   .join("|");
          const data = {
            prjId,
            topic: "催办提醒：" + taskName,
            targetItemName: taskName,
            targetItemType: 0,
            urgeObjectiveUserId: taskUserId,
            urgeObjectiveName: taskUserName,
            targetItemId: taskId,
            specificItemType: 0,
            taskType,
            taskTypeName
          };
          request.urgePlan(data).then((res) => {
            if (res.result === "0") {
              this.$message.success("催办成功");
              this.initTaskData();
              this.countGridCellW();
              this.scrollTo(x, y);
            } else {
              this.$message.warning(res.message || "催办失败");
            }
          });
        } else {
          this.$message.warning("责任人不能为空");
        }
      });
    },
    delPlan(id) {
      this.$confirm("确定删除此计划吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request.delPlan(id).then((res) => {
          if (res.result === "0") {
            gantt.deleteTask(id);
            this.initTaskData();
            this.resetCurrentTask();
            this.$message.success("删除成功");
          }
        });
      });
    },
    move(id, type) {
      request.movePlan(id, type).then((res) => {
        if (res.result === "0") {
          this.initTaskData();
          this.$message.success("移动成功");
        }
      });
    },

    upgrade(id, type) {
      const tasks = gantt.getTaskBy((task) => task.id === id);
      const { preTaskName, afterTaskName } = tasks[0];
      if (preTaskName || afterTaskName) {
        this.$confirm(
          type === 0 ? "当前计划已关联其他计划，进行升级操作后，关联关系将自动丢失，是否确认升级？" : "当前计划已关联其他计划，进行降级操作后，关联关系将自动丢失，是否确认降级？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.upAndDownPlan(id, type);
        });
      } else {
        this.upAndDownPlan(id, type);
      }
    },

    upAndDownPlan(id, type) {
      request.upAndDownPlan(id, type).then((res) => {
        if (res.result === "0") {
          this.initTaskData();
          this.$message.success(`${type === 0 ? "升级" : "降级"}成功`);
        }
      });
    },

    newLabel() {
      gantt.bindSetHeaderClick = this.bindSetHeaderClick;
      return `<div style="display: flex;align-items: center;height: 100%;cursor: pointer;justify-content: center;position: relative;">
              <p id="setHeader" onclick="gantt.bindSetHeaderClick()"/>
            </div>`;
    },
    // 收起/展开事件
    toggleFold() {
      const { x, y } = gantt.getScrollState();
      this.foldStatus = !this.foldStatus;
      this.renderGantt();
      this.countGridCellW();
      this.scrollTo(x, y);
    },

    // 设置确定按钮
    setHeaderConfirm() {
      const { x, y } = gantt.getScrollState();
      this.isShowSetHeader = false;
      if (!this.foldStatus || this.isList) {
        this.renderGantt();
      }
      this.countGridCellW();
      if (this.isList) {
        this.oldCheckListList = [...this.checkList];
      } else {
        this.oldCheckListGantt = [...this.checkList];
      }
      this.filterColumns = [...this.checkList];
      this.renderGantt();
      this.scrollTo(x, y);
    },
    // 设置取消按钮
    cancelSetHeader() {
      this.isShowSetHeader = false;
      if (this.isList) {
        this.checkList = [...this.oldCheckListList];
      } else {
        this.checkList = [...this.oldCheckListGantt];
      }
    },
    async renderGantt() {
      gantt.config.show_chart = !this.foldStatus && !this.isList;
      gantt.config.columns = this.doFilterColumns;
      gantt.init(this.$refs.gantt);
      gantt.parse(this.tasks);
    },
    scrollTo(x, y) {
      gantt.scrollTo(x, y);
    },

    labelChange(value) {
      gantt.refreshData();
    },

    showTypeChange() {
      this.showType = !this.showType;
      this.initTaskData();
    },

    timeGapChange() {
      const { x, y } = gantt.getScrollState();
      this.initGantt();
      this.configTimeGap;
      this.renderGantt();
      this.countGridCellW();
      this.scrollTo(x, y);
    },

    // 甘特图和列表切换
    mapChange(value) {
      const { x, y } = gantt.getScrollState();
      gantt.config.show_chart = value === "0";
      if (value === "1") {
        this.isList = true;
        this.checkList = this.oldCheckListList;
      } else {
        this.isList = false;
        this.checkList = this.oldCheckListGantt;
        this.initTaskData();
      }
      this.filterColumns = this.checkList;
      this.renderGantt();
      this.countGridCellW();
      this.scrollTo(x, y);
    },

    resetCurrentTask() {
      this.currentTaskId = "";
      this.currentTask = {};
    },

    countGridCellW() {
      this.$nextTick(() => {
        this.gridCellW = this.getGridCellWidth();
        this.setHeaderLeft = this.gridCellW - 140 + 15 + "px";
      });
    },

    // 点击 设置 图标
    bindSetHeaderClick() {
      this.$nextTick(() => {
        this.gridCellW = this.getGridCellWidth();
        this.setHeaderLeft = this.gridCellW - 140 + 15 + "px";
        this.isShowSetHeader = !this.isShowSetHeader;
        if (this.isList) {
          this.checkList = this.oldCheckListList;
        } else {
          this.checkList = this.oldCheckListGantt;
        }
      });
    },
    getGridCellWidth() {
      const wrapper = this.$el.querySelector(".gantt_layout_root");
      const cell = this.$el.querySelector(".grid_cell");
      const wrapperWidth = wrapper?.clientWidth || 0;
      const cellWidth = cell?.clientWidth || 0;
      return Math.min(cellWidth, wrapperWidth);
    },

    handlePreTaskCheckChange(data, nodes) {
      this.preTaskChecks = nodes.checkedNodes;
    },

    linkTaskClose() {
      const preTaskList = this.currentTask.preTaskList || [];
      const oldPreTaskList = preTaskList.filter((item) => !item.old);
      if (this.splicePreTaskList[0]) {
        this.splicePreTaskList.forEach((item) => {
          oldPreTaskList.push(item);
        });
      }
      const { id } = this.currentTask;
      this.currentTask.preTaskList = oldPreTaskList;
      let dataTask = this.tasks.data.find((item) => item.id === id);
      dataTask = dataTask || {};
      dataTask.preTaskList = oldPreTaskList;
      this.isShowLinkTaskBox = false;
      this.splicePreTaskList = [];
      this.setParentDisabledArr = new Set();
    },

    addPreTask() {
      this.preTaskChecks.forEach((item) => {
        const { taskId, taskName } = item;
        const obj = {
          relaStatus: this.preTaskRadio,
          preTaskId: taskId,
          preTaskName: taskName,
          old: true
        };
        if (!this.currentTask.preTaskList.some((Item) => Item.preTaskId === obj.preTaskId)) {
          this.currentTask.preTaskList.push(obj);
        }
      });
      this.preTaskClose();
    },

    preTaskClose() {
      this.preTaskRadio = "0";
      this.preTaskFilterText = "";
      this.preTaskChecks = [];
      this.treeTask = [...this.treeTask];
      this.isShowPreTaskBox = false;
    },

    preTaskFilterNode(value, data) {
      if (!value) return true;
      return data.taskName.indexOf(value) !== -1;
    },

    addLinkTask() {
      const { preTaskList, taskId, taskName } = this.currentTask;
      const relationTaskList = preTaskList.map((item) => ({
        relaStatus: item.relaStatus,
        taskId: item.preTaskId,
        taskName: item.preTaskName
      }));
      request.addLinkTask({ relationTaskList, taskId, taskName }).then((res) => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.isShowLinkTaskBox = false;
          this.initTaskData();
        }
      });
    },

    addOnDay(time, num) {
      return moment(time).add(num, "days").format("YYYY-MM-DD");
    }
  },

  beforeRouteLeave(to, from, next) {
    gantt.detachEvent(this.myTaskClickEvent);
    this.myTaskClickEvent = "";
    this.labelFilterValue = [];
    next();
  }
};
</script>

<style lang="scss" scoped src="./list.scss"></style>
